import { useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { Skeleton } from "@mui/material";

import { NewButton } from "./index";
import speakersData from "../data/speakers_dyn.json";
const filledArray = new Array(90).fill("hello");
const localSpeakersData = [...speakersData.speakers];

localSpeakersData.sort((a, b) =>
   a.lastname.toLowerCase().localeCompare(b.lastname.toLowerCase())
);

const speakers1 = localSpeakersData.splice(0, 20)

const res = localSpeakersData.reduce((resultArray, item, index) => {
   const chunkIndex = Math.floor(index / (localSpeakersData.length / 4));
   if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
   }
   resultArray[chunkIndex].push(item);
   return resultArray;
}, []);

export const Investors = () => {
   const [open, setOpen] = useState(false);
   const [modalInfo, setModalInfo] = useState({});
   const handleClose = () => setOpen(false);


   const [speakers2, setSpeakers2] = useState({
      speakers: res[0],
      display: "none",
   });
   const [speakers3, setSpeakers3] = useState({
      speakers: res[1],
      display: "none",
   });
   const [speakers4, setSpeakers4] = useState({
      speakers: res[2],
      display: "none",
   });
   const [speakers5, setSpeakers5] = useState({
      speakers: res[3],
      display: "none",
   });


   if (localSpeakersData.length === 0) {
      return <div style={{ margin: "0 auto", width: "95%", display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
         {
            filledArray.map((inv, index) => {
               return <div key={Math.random()}>
                  <Skeleton
                     variant="rectangular"
                     width={window.innerWidth > 900 ? 270 : 230}
                     height={230}
                     style={{ margin: window.innerWidth > 900 ? "1rem" : "0.5rem" }}
                  />
               </div>
            })
         }
      </div>
   }

   const firstSpeakerArr = speakers1.map((speaker, i) => {
      return (
         <Grid
            className="grid-item"
            key={i}
            item
            xs={1}
            sm={1}
            lg={1}
            xl={1}
            sx={{ maxWidth: "340px !important" }}
         >
            <div
               className="speaker-card"
               style={{
                  borderRadius: "10px",
                  margin: "1rem",
                  padding: "1rem",
                  alignItems: "stretch",
                  maxWidth: "340px",
                  height: "90%",
               }}
               key={i}
               onClick={() => {
                  setModalInfo({
                     name: speaker.firstname + " " + speaker.lastname,
                     bio: speaker.bio,
                     headshotUrl: speaker.speaker_head_shot_to_display,
                     company: speaker.company,
                  });
                  setOpen(true);
               }}
            >
               <img
                  alt={speaker.firstname} src={speaker.speaker_head_shot_to_display}
                  style={{
                     borderRadius: "5px",
                     width: "100%",
                     height: "auto",
                     border: "2px solid #092CA8",
                     boxShadow: "-3px -1px 15px 2px rgba(0,0,0,0.49)",
                  }}
               />
               <div
                  style={{
                     color: "#00C2FF",
                     fontSize: "1.15rem",
                     textTransform: "uppercase",
                     fontWeight: "900",
                     marginTop: "1.5vh",
                  }}
               >
                  {speaker.firstname} {speaker.lastname}
               </div>
               <div
                  style={{ color: "black", fontSize: "1.15rem", fontWeight: "900" }}
               >
                  {speaker.company}
               </div>
            </div>
         </Grid>
      );
   });

   const secondSpeakerArr = speakers2.speakers.map((speaker, i) => (
      <Grid
         key={i}
         item
         xs={1}
         sm={1}
         lg={1}
         xl={1}
         sx={{ display: speakers2.display }}
      >
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               alignItems: "stretch",
               height: "90%",
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt={speaker.firstname} src={speaker.speaker_head_shot_to_display}
               style={{
                  borderRadius: "5px",
                  width: "100%",
                  height: "auto",
                  border: "2px solid #092CA8",
                  boxShadow: "-3px -1px 15px 2px rgba(0,0,0,0.49)",
               }}
            />
            <div
               className="investor-name"
               style={{
                  color: "#00C2FF",
                  fontSize: "1.15rem",
                  textTransform: "uppercase",
                  fontWeight: "900",
                  marginTop: "1.5vh",
               }}
            >
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="investor-company"
               style={{ color: "black", fontSize: "1.15rem", fontWeight: "900" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const thirdSpeakerArr = speakers3.speakers.map((speaker, i) => (
      <Grid
         item
         key={i}
         xs={1}
         sm={1}
         lg={1}
         xl={1}
         sx={{ display: speakers2.display }}
      >
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               display: speakers3.display,
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt={speaker.firstname} src={speaker.speaker_head_shot_to_display}
               style={{
                  borderRadius: "5px",
                  width: "100%",
                  height: "auto",
                  border: "2px solid #092CA8",
                  boxShadow: "-3px -1px 15px 2px rgba(0,0,0,0.49)",
               }}
            />
            <div
               className="investor-name"
               style={{
                  color: "#00C2FF",
                  fontSize: "1.15rem",
                  textTransform: "uppercase",
                  fontWeight: "900",
                  marginTop: "1.5vh",
               }}
            >
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="investor-company"
               style={{ color: "black", fontSize: "1.15rem", fontWeight: "900" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const fourthSpeakerArr = speakers4.speakers.map((speaker, i) => (
      <Grid
         key={i}
         item
         xs={1}
         sm={1}
         lg={1}
         xl={1}
         sx={{ display: speakers2.display }}
      >
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               display: speakers4.display,
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt={speaker.firstname} src={speaker.speaker_head_shot_to_display}
               style={{
                  borderRadius: "5px",
                  width: "100%",
                  height: "auto",
                  border: "2px solid #092CA8",
                  boxShadow: "-3px -1px 15px 2px rgba(0,0,0,0.49)",
               }}
            />
            <div
               className="investor-name"
               style={{
                  color: "#00C2FF",
                  fontSize: "1.15rem",
                  textTransform: "uppercase",
                  fontWeight: "900",
                  marginTop: "1.5vh",
               }}
            >
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="investor-company"
               style={{ color: "black", fontSize: "1.15rem", fontWeight: "900" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const fifthSpeakerArr = speakers5.speakers.map((speaker, i) => (
      <Grid
         key={i}
         item
         xs={1}
         sm={1}
         lg={1}
         xl={1}
         sx={{ display: speakers2.display }}
      >
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               display: speakers5.display,
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt={speaker.firstname} src={speaker.speaker_head_shot_to_display}
               style={{
                  borderRadius: "5px",
                  width: "100%",
                  height: "auto",
                  border: "2px solid #092CA8",
                  boxShadow: "-3px -1px 15px 2px rgba(0,0,0,0.49)",
               }}
            />
            <div
               className="investor-name"
               style={{
                  color: "#00C2FF",
                  fontSize: "1.15rem",
                  textTransform: "uppercase",
                  fontWeight: "900",
                  marginTop: "1.5vh",
               }}
            >
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="investor-company"
               style={{ color: "black", fontSize: "1.15rem", fontWeight: "900" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   return (
      <div style={{ backgroundColor: "white", justifyContent: "center" }}>
         <Dialog
            disableScrollLock
            open={open}
            onClose={handleClose}
            sx={{ justifyContent: "center", textAlign: "center" }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogTitle id="alert-dialog-title">
               <div>{modalInfo.name}</div>
               <div>{modalInfo.company}</div>
            </DialogTitle>
            <DialogContent>
               <img alt={modalInfo.name} src={modalInfo.headshotUrl} />
               <DialogContentText
                  sx={{ marginTop: "1rem" }}
                  id="alert-dialog-description"
               >
                  {modalInfo.bio}
               </DialogContentText>
            </DialogContent>
            <DialogActions>
               <Button onClick={handleClose} variant="secondary" autoFocus>
                  Close
               </Button>
            </DialogActions>
         </Dialog>

         <h1
            id="custom-stop"
            style={{
               backgroundColor: "white",
               textAlign: "center",
               color: "#092CA8",
               padding: "7.5vh 0vw 2.5vh 0vw",
               fontWeight: "900",
            }}
         >
            OVER 140 FEATURED INVESTORS
         </h1>
         <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
            <Box sx={{ flexGrow: 0 }}>
               <Grid
                  container
                  spacing={0}
                  columns={{ xs: 2, sm: 3, md: 5, lg: 5, xl: 5 }}
                  style={{
                     margin: "auto",
                     paddingRight: "5%",
                     justifyContent: "center",
                     paddingLeft: "5%",
                     maxWidth: "1698px",
                  }}
                  columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }}
               >
                  {firstSpeakerArr}
                  {secondSpeakerArr}
                  {thirdSpeakerArr}
                  {fourthSpeakerArr}
                  {fifthSpeakerArr}
               </Grid>
            </Box>
         </div>
         <div style={{ justifyContent: "center", textAlign: "center" }}>
            <div
               style={{
                  margin: "2.5% auto",
                  width: window.innerWidth < 900 ? "70%" : "20%",
               }}
               onClick={() => {
                  if (speakers2.display === "none") {
                     setSpeakers2({ ...speakers2, display: null });
                  }
                  if (speakers2.display === null && speakers3.display === "none") {
                     setSpeakers2({ ...speakers2, display: null });
                     setSpeakers3({ ...speakers3, display: null });
                  }
                  if (
                     speakers2.display === null &&
                     speakers3.display === null &&
                     speakers4.display === "none"
                  ) {
                     setSpeakers2({ ...speakers2, display: null });
                     setSpeakers3({ ...speakers3, display: null });
                     setSpeakers4({ ...speakers4, display: null });
                  }
                  if (
                     speakers2.display === null &&
                     speakers3.display === null &&
                     speakers4.display === null &&
                     speakers5.display === "none"
                  ) {
                     setSpeakers2({ ...speakers2, display: null });
                     setSpeakers3({ ...speakers3, display: null });
                     setSpeakers4({ ...speakers4, display: null });
                     setSpeakers5({ ...speakers5, display: null });
                  }
               }}
            >
               <NewButton
                  name={
                     speakers2.display == null &&
                        speakers3.display == null &&
                        speakers4.display == null &&
                        speakers5.display == null
                        ? "MORE INVESTORS COMING..."
                        : "SHOW MORE"
                  }
                  bgColor={"black"}
                  color={"white"}
               />
            </div>
         </div>
      </div>
   );
};
